import { API_OAMARELINHO } from '@/constants';
import { Deficiency } from '@/types/curriculum';
import axios from 'axios';
import UserService from './User.service';

export class DeficienciesService {
  static async fetchDeficiencies(): Promise<Deficiency[]> {
    const response = await axios.get<Deficiency[]>(`${API_OAMARELINHO}deficiencies`, {
      headers: { Authorization: `Bearer ${UserService.getUserData()?.token}` },
    });
    return response.data;
  }
}